import blackMembershipPNG from 'assets/black_membership.png';
import blackPlusMembershipPNG from 'assets/black_plus_membership.png';
import goldMembershipPNG from 'assets/gold_membership.png';
import silverMembershipPNG from 'assets/silver_membership.png';
import dynastyMembershipPNG from 'assets/dynasty_membership.png';
import dynastyDiningMembershipPNG from 'assets/dynasty_dining_membership.png';

import partnersHeaderPNG from 'assets/partners_header.png';
import partnersFooterPNG from 'assets/partners_footer.png';
import travelJournalHeroWEBP from 'assets/travel-journal-hero.webp';

export {
  blackMembershipPNG,
  blackPlusMembershipPNG,
  goldMembershipPNG,
  silverMembershipPNG,
  dynastyMembershipPNG,
  dynastyDiningMembershipPNG,
  partnersHeaderPNG,
  partnersFooterPNG,
  travelJournalHeroWEBP,
};
